import React from 'react';
import { Card } from '../components/ui/card';
import { AlertTriangle } from 'lucide-react';
import SEO from '../components/SEO';

const MedicalDisclaimer = () => {
  return (
    <main className="pt-24 bg-[#FDFDFB]">
      <SEO 
        title="Medical Disclaimer"
        description="Important medical disclaimer and information about services provided by Harmony Behavioral & Psychiatric Health."
      />

      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <Card className="p-8 md:p-12 bg-white border-[#d4cec5]">
              <div className="flex items-center gap-3 mb-6">
                <AlertTriangle className="text-[#c9b17a]" size={40} />
                <h1 className="text-4xl font-bold text-[#7a8a72]">Medical Disclaimer</h1>
              </div>

              <h2 className="text-2xl font-semibold text-[#7a8a72] mb-4">Harmony Behavioral & Psychiatric Health</h2>

              <div className="space-y-6 text-[#3a3a3a]">
                <p className="leading-relaxed">
                  The information provided on this website is for general informational purposes only and is not intended as a substitute for professional medical advice, diagnosis, or treatment.
                </p>

                <p className="leading-relaxed">
                  All clinical services provided by Harmony Behavioral & Psychiatric Health occur within the context of a formal provider–patient relationship established through a scheduled appointment, appropriate clinical evaluation, and proper documentation.
                </p>

                <div>
                  <h3 className="text-xl font-semibold text-[#7a8a72] mb-3">Nothing on this website should be construed as:</h3>
                  <ul className="list-disc pl-6 space-y-2">
                    <li>Medical advice</li>
                    <li>Mental health treatment</li>
                    <li>Diagnosis</li>
                    <li>Clinical instruction</li>
                    <li>Emergency care guidance</li>
                  </ul>
                </div>

                <p className="leading-relaxed font-semibold">
                  You should not delay, avoid, or substitute professional medical or psychiatric care based on information found on this website.
                </p>

                <Card className="p-6 bg-red-50 border-red-200">
                  <p className="text-red-800 font-semibold mb-2">
                    If you are experiencing a medical or psychiatric emergency, call 911 immediately or contact the Suicide & Crisis Lifeline at 988.
                  </p>
                  <p className="text-red-700">
                    Harmony Behavioral & Psychiatric Health does not provide emergency services through this website, email, phone, or electronic messaging.
                  </p>
                </Card>

                <p className="leading-relaxed font-semibold">
                  Use of this website does not establish a provider–patient relationship.
                </p>
              </div>
            </Card>
          </div>
        </div>
      </section>
    </main>
  );
};

export default MedicalDisclaimer;